import { Building2, User } from "lucide-react";

export const ProfileIcon = ({
	type,
	size = 14,
	className = "",
}: {
	type: string;
	size?: number;
	className?: string;
}) => {
	return type === "company" ? (
		<Building2 size={size} className={className} />
	) : (
		<User size={size} className={className} />
	);
};
